export default "__VITE_ASSET__2892143c__"